// Image processing constants
export const JPEG_QUALITY = 0.9;
export const BAKED_JPEG_QUALITY = 0.92;

// Carousel constants
export const CAROUSEL_WINDOW_SIZE = 9;
export const CAROUSEL_ITEM_WIDTH = 80;
export const CAROUSEL_ITEM_MARGIN = 8;
export const CAROUSEL_ITEM_TOTAL_WIDTH =
  CAROUSEL_ITEM_WIDTH + CAROUSEL_ITEM_MARGIN; // 88px
export const CAROUSEL_VIEWPORT_WIDTH =
  (CAROUSEL_WINDOW_SIZE + 2) * CAROUSEL_ITEM_TOTAL_WIDTH; // 968px, +2 is for buttons
export const CAROUSEL_HEIGHT = 80;
export const CAROUSEL_THUMBNAIL_HEIGHT = 60;

// Edit control defaults
export const DEFAULT_BRIGHTNESS = 100;
export const DEFAULT_CONTRAST = 100;
export const DEFAULT_SATURATION = 100;
export const DEFAULT_ROTATION = 0;

// Slider ranges
export const BRIGHTNESS_MIN = 50;
export const BRIGHTNESS_MAX = 150;
export const CONTRAST_MIN = 50;
export const CONTRAST_MAX = 150;
export const SATURATION_MIN = 50;
export const SATURATION_MAX = 150;

// Rotation constants
export const ROTATION_STEP = 90;

// Crop aspect ratios
export const FOUR_THREE_RATIO = 4 / 3;

// Drag handle size
export const DRAG_HANDLE_SIZE = 10;
export const DRAG_HANDLE_OFFSET = 5;

// Overlay opacity
export const CROP_OVERLAY_OPACITY = 0.5;

// Border styles
export const CROP_BORDER_COLOR = 'white';
export const CROP_BORDER_WIDTH = 2;
